import { useContext } from "react";
import { Outlet } from "react-router";
import NoPermission from "../components/ui/NoPermission";
import { AuthContext } from "../contexts/authContext";
import LecturerSidebar from "../pages/Lecturer/components/LecturerSidebar";

function LecturerLayout() {
  const { user } = useContext(AuthContext);

  if (user?.user_type !== "lecturer") {
    return <NoPermission />;
  }

  return (
    <LecturerSidebar>
      <Outlet />
    </LecturerSidebar>
  );
}

export default LecturerLayout;
